import styled from 'styled-components';
import { memo, useEffect, useState, lazy } from 'react';
const AsciiImageViewer = lazy(() => import('../components/AsciiImageViewer'));

const Grid = styled.div`
  display: grid;
  gap: 10px;
  grid-auto-rows: minmax(100px, 1fr);
  grid-auto-flow: row;
  ${({ maxAdjacent }) => `
    @media (min-width: 1024px) {
      grid-template-columns: repeat(${maxAdjacent + 2}, 1fr);
    }
    @media (min-width: 768px) and (max-width: 1023px) {
      grid-template-columns: repeat(${Math.max(maxAdjacent + 1, 3)}, 1fr);
    }
    @media (max-width: 767px) {
      grid-template-columns: repeat(3, 1fr);
    }
  `}
`;

const GridItem = styled.div`
  aspect-ratio: 1;
  ${({ isLarge }) => isLarge ? `
    grid-column: 1 / span 2;
    grid-row: 1 / span 2;
    min-width: 200px;
    min-height: 200px;
  ` : `
    grid-column: span 1;
    grid-row: span 1;
  `}
`;

const MediaGrid = memo(
  function MediaGrid({ items, maxAdjacent = 2, isTouchScreen = false}) {
    const [releases, setReleases] = useState([]);

    const getReleases = async () => {
      let f1 = await fetch("https://h3llo-wor1d.github.io/static.hyperpup.pet/releases.json");
      let f2 = await f1.json();
      setReleases(f2.releases);
      localStorage.setItem("releases", JSON.stringify(f2.releases));
    }

    useEffect(() => {
      getReleases();
    }, []);

    if (!releases || releases.length === 0) {
        return <Grid maxAdjacent={maxAdjacent}>
            {Array.from({ length: 9 }, (_, i) => 
              <GridItem key={i} isLarge={i === 0}>
                <div style={{width: "100%", height: "100%", backgroundColor: "#e5e5e5"}} />
              </GridItem>
            )}
        </Grid>;
    }

    return (
      <Grid maxAdjacent={maxAdjacent}>
        {releases.map((item, index) => (
          <GridItem key={index} isLarge={index === 0}>
            <AsciiImageViewer src={item.media} cols={index === 0 ? 100 : 50} redirectTo={item.path} mode={isTouchScreen ? 0 : null}/>
          </GridItem>
        ))}
      </Grid>
    );
}
) 

export default MediaGrid;
